var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cSplashMedia'),_c('div',{staticClass:"row home-card"},[_vm._l((_vm.homePages),function(p){return [_c('cHomeCardElement',{key:p.HomePageCardId,attrs:{"element":p,"editor":false}})]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }